import React, { FC } from 'react'

import SanityLink from '../../global/SanityLink'
import { DataSheetLinkProps } from './DataSheetLink'

interface DataSheetLinkListProps {
  dataSheets: DataSheetLinkProps[]
  isProfessional?: boolean
  title: string
}

const DataSheetLinkList: FC<DataSheetLinkListProps> = ({
  dataSheets,
  isProfessional = false,
  title,
}) => {
  const isEmpty = dataSheets.every((sheet) => !sheet.href)

  if (!isProfessional || isEmpty) {
    return null
  }

  return (
    <div className="flex-1 space-y-5">
      <h3 className="text-brand-navy-2 text-lg font-[350]">{title}</h3>
      <ul className="list-disc flex flex-col gap-4 pl-4">
        {dataSheets.map((sheet) => {
          if (!sheet.href) {
            return null
          }

          return (
            <li key={sheet.id}>
              <SanityLink
                to={sheet.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Data Sheet Link"
                className="text-brand-blue hover:text-brand-blue-dark underline text-lg font-[350]"
              >
                {sheet.text}
              </SanityLink>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default DataSheetLinkList
